import React from 'react';
import { useField, connect } from 'formik';
import { KeyboardDatePicker } from '@material-ui/pickers';

interface Props {
    name: string,
    label: string,
    fullWidth: boolean,
    placeholder: string,
}

const FormikDatePicker = ({ name, ...props }: Props) => {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input> and also replace ErrorMessage entirely.
  const [field, meta] = useField({ name });
  const error = meta.touched && meta.error;
  return (
    <KeyboardDatePicker
      {...field}
      {...props}
        // @ts-ignore
      onChange={(date) => props.formik.setFieldValue(field.name, date.format('YYYY-MM-DD'), false)}
      disableToolbar
      variant="inline"
      format="MM/DD/YYYY"
      inputVariant="outlined"
      InputLabelProps={{
        shrink: true,
      }}
      KeyboardButtonProps={{
        'aria-label': 'change date',
      }}
      helperText={error}
      error={Boolean(error)}
    />
  );
};

export default connect(FormikDatePicker);
